module.exports = __webpack_public_path__ + "static/img/ke03_benefit.2b886ff1.png";